import React, { useState, useMemo, useEffect, useCallback, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight, X, ChevronLeft, ChevronRight } from "lucide-react";
import { RevealText, Reveal } from "@/components/Reveal";
import Img from "@/components/Img";
import { CATEGORIES, IMAGES } from "@/data/content";

const GALLERY = [
  { cat: "families", src: "/family-6.jpg", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/st-julien-1.jpg", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/st-julien-2.jpg", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/st-julien-3.jpg", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/st-julien-4.jpg", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/st-julien-5.jpg", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/southside-1.jpg", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/southside-2.jpg", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/southside-3.jpg", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/southside-4.jpg", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/southside-5.jpg", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/helms-4.jpg", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/helms-13.jpg", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/helms-22.jpg", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/helms-58.jpg", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/helms-94.jpg", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/family-new-1.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/family-new-2.webp", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/family-new-3.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/family-new-4.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/family-new-5.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/family-new-6.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/family-new-7.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/family-new-8.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/family-new-9.webp", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/family-new-10.webp", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/ul-alumni-11.jpg", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/ul-alumni-12.jpg", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/ul-alumni-13.jpg", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/ul-alumni-14.jpg", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/ul-alumni-15.jpg", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/magnolia-1.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/magnolia-2.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/magnolia-3.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/magnolia-4.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/magnolia-5.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/family-1.jpg", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/family-2.jpg", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/family-3.jpg", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/family-4.jpg", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/family-5.jpg", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/family-7.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/neighborhood-1.webp", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/neighborhood-2.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/neighborhood-3.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/neighborhood-4.webp", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/neighborhood-5.webp", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/family-8.webp", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/family-9.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/family-10.webp", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/family-11.webp", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/family-12.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/family-13.webp", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/family-14.webp", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/family-15.webp", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/family-16.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/family-17.jpg", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/family-18.jpg", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/family-19.jpg", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/wavy-136.jpg", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/wavy-77.jpg", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/family-studio-1.webp", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/hoang-34.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/hoang-249.webp", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/hoang-68.webp", ratio: "aspect-[3/2]" },
  { cat: "families", src: "/hoang-201.webp", ratio: "aspect-[3/4]" },
  { cat: "families", src: "/hoang-123.webp", ratio: "aspect-[3/2]" },
  { cat: "maternity", src: "/maternity-1.jpg", ratio: "aspect-[3/4]" },
  { cat: "maternity", src: "/maternity-2.jpg", ratio: "aspect-[3/4]" },
  { cat: "maternity", src: "/maternity-3.jpg", ratio: "aspect-[3/4]" },
  { cat: "maternity", src: "/maternity-4.jpg", ratio: "aspect-[4/5]" },
  { cat: "maternity", src: "/maternity-5.jpg", ratio: "aspect-[3/4]" },
  { cat: "maternity", src: "/maternity-6.jpg", ratio: "aspect-[3/4]" },
  { cat: "maternity", src: "/maternity-7.jpg", ratio: "aspect-[3/4]" },
  { cat: "maternity", src: "/maternity-8.jpg", ratio: "aspect-[3/2]" },
  { cat: "maternity", src: "/maternity-9.jpg", ratio: "aspect-[3/2]" },
  { cat: "maternity", src: "/maternity-10.jpg", ratio: "aspect-[3/4]" },
  { cat: "maternity", src: "/boudreaux-31.jpg", ratio: "aspect-[3/4]" },
  { cat: "maternity", src: "/boudreaux-3.jpg", ratio: "aspect-[3/4]" },
  { cat: "maternity", src: "/boudreaux-39.jpg", ratio: "aspect-[3/2]" },
  { cat: "maternity", src: "/maternity-jungle.webp", ratio: "aspect-[3/2]" },
  { cat: "maternity", src: "/lavergne-88.webp", ratio: "aspect-[3/4]" },
  { cat: "maternity", src: "/lavergne-41.webp", ratio: "aspect-[3/2]" },
  { cat: "maternity", src: "/lavergne-102.webp", ratio: "aspect-[3/4]" },
  { cat: "maternity", src: "/lavergne-108.webp", ratio: "aspect-[3/4]" },
  { cat: "maternity", src: "/lavergne-29.webp", ratio: "aspect-[3/4]" },
  { cat: "fresh48", src: "/fresh48-noah.jpg", ratio: "aspect-[3/2]" },
  { cat: "fresh48", src: "/fresh48-noah2.jpg", ratio: "aspect-[3/4]" },
  { cat: "fresh48", src: "/fresh48-noah3.jpg", ratio: "aspect-[3/2]" },
  { cat: "fresh48", src: "/fresh48-1.jpg", ratio: "aspect-[3/4]" },
  { cat: "fresh48", src: "/fresh48-2.jpg", ratio: "aspect-[3/4]" },
  { cat: "fresh48", src: "/fresh48-3.jpg", ratio: "aspect-[3/4]" },
  { cat: "fresh48", src: "/fresh48-baby-1.jpg", ratio: "aspect-[3/2]" },
  { cat: "fresh48", src: "/fresh48-baby-2.jpg", ratio: "aspect-[3/4]" },
  { cat: "fresh48", src: "/fresh48-baby-3.jpg", ratio: "aspect-[3/2]" },
  { cat: "fresh48", src: "/fresh48-baby-4.jpg", ratio: "aspect-[3/4]" },
  { cat: "fresh48", src: "/fresh48-baby-5.jpg", ratio: "aspect-[3/4]" },
  { cat: "couples", src: IMAGES.couples, ratio: "aspect-[4/5]" },
  { cat: "couples", src: "/baileechristian-73.jpg", ratio: "aspect-[3/4]" },
  { cat: "couples", src: "/baileechristian-47.jpg", ratio: "aspect-[3/2]" },
  { cat: "couples", src: "/baileechristian-52.jpg", ratio: "aspect-[3/4]" },
  { cat: "couples", src: "/couples-2.webp", ratio: "aspect-[3/2]" },
  { cat: "couples", src: "/couples-3.webp", ratio: "aspect-[3/4]" },
  { cat: "couples", src: "/couples-4.webp", ratio: "aspect-[3/2]" },
  { cat: "couples", src: "/couples-5.webp", ratio: "aspect-[3/4]" },
  { cat: "couples", src: "/leblanc-33.jpg", ratio: "aspect-[3/2]" },
  { cat: "couples", src: "/leblanc-37.jpg", ratio: "aspect-[3/4]" },
  { cat: "couples", src: "/elizabeth-5.jpg", ratio: "aspect-[3/2]" },
  { cat: "couples", src: "/elizabeth-31.jpg", ratio: "aspect-[3/4]" },
  { cat: "couples", src: "/elizabeth-47.jpg", ratio: "aspect-[3/2]" },
  { cat: "couples", src: "/elizabeth-67.jpg", ratio: "aspect-[3/2]" },
  { cat: "couples", src: "/elizabeth-75.jpg", ratio: "aspect-[3/2]" },
  { cat: "seniors", src: "/senior-1.webp", ratio: "aspect-[3/2]" },
  { cat: "seniors", src: "/senior-2.webp", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/lana-1.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/lana-2.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/lana-3.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/lana-4.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/lana-5.jpg", ratio: "aspect-[3/2]" },
  { cat: "seniors", src: "/lana-6.jpg", ratio: "aspect-[3/2]" },
  { cat: "seniors", src: "/lana-7.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/lana-8.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/lana-9.jpg", ratio: "aspect-[3/4]" },
  { cat: "branding", src: "/branding-1.jpg", ratio: "aspect-[3/2]" },
  { cat: "branding", src: "/andree-85.jpg", ratio: "aspect-[3/4]" },
  { cat: "branding", src: "/andree-77.jpg", ratio: "aspect-[3/4]" },
  { cat: "branding", src: "/andree-132.jpg", ratio: "aspect-[3/4]" },
  { cat: "branding", src: "/andree-117.jpg", ratio: "aspect-[3/4]" },
  { cat: "branding", src: "/andree-97.jpg", ratio: "aspect-[3/4]" },
  { cat: "branding", src: "/branding-2.webp", ratio: "aspect-[3/4]" },
  { cat: "branding", src: "/branding-3.webp", ratio: "aspect-[3/4]" },
  { cat: "branding", src: "/branding-4.webp", ratio: "aspect-[3/4]" },
  { cat: "branding", src: "/branding-5.webp", ratio: "aspect-[3/4]" },
  { cat: "branding", src: "/branding-6.webp", ratio: "aspect-[3/4]" },
  { cat: "branding", src: "/eon-1.webp", ratio: "aspect-[3/2]" },
  { cat: "branding", src: "/eon-5.webp", ratio: "aspect-[3/2]" },
  { cat: "branding", src: "/eon-3.webp", ratio: "aspect-[3/2]" },
  { cat: "branding", src: "/eon-4.webp", ratio: "aspect-[3/2]" },
  { cat: "branding", src: "/eon-2.webp", ratio: "aspect-[3/2]" },
  { cat: "branding", src: "/eon-6.webp", ratio: "aspect-[3/2]" },
  { cat: "branding", src: "/eon-7.webp", ratio: "aspect-[3/2]" },
  { cat: "branding", src: "/eon-8.webp", ratio: "aspect-[3/2]" },
  { cat: "branding", src: "/eon-9.webp", ratio: "aspect-[3/2]" },
  { cat: "branding", src: "/eon-10.webp", ratio: "aspect-[3/2]" },
  { cat: "branding", src: "/eon-11.webp", ratio: "aspect-[3/2]" },
  { cat: "branding", src: "/eon-12.webp", ratio: "aspect-[3/2]" },
  { cat: "branding", src: "/cyclebar-1.jpg", ratio: "aspect-[3/2]" },
  { cat: "branding", src: "/cyclebar-2.jpg", ratio: "aspect-[3/4]" },
  { cat: "branding", src: "/cyclebar-3.jpg", ratio: "aspect-[3/4]" },
  { cat: "branding", src: "/cyclebar-4.jpg", ratio: "aspect-[3/4]" },
  { cat: "branding", src: "/cyclebar-5.jpg", ratio: "aspect-[3/2]" },
  { cat: "newborn", src: "/newborn-lifestyle.jpg", ratio: "aspect-[4/5]" },
  { cat: "newborn", src: "/newborn-2.jpg", ratio: "aspect-[3/4]" },
  { cat: "newborn", src: "/newborn-3.jpg", ratio: "aspect-[3/4]" },
  { cat: "newborn", src: "/newborn-4.jpg", ratio: "aspect-[3/4]" },
  { cat: "newborn", src: "/newborn-5.jpg", ratio: "aspect-[3/4]" },
  { cat: "newborn", src: "/newborn-6.jpg", ratio: "aspect-[3/2]" },
  { cat: "newborn", src: "/newborn-7.jpg", ratio: "aspect-[3/4]" },
  { cat: "newborn", src: "/allbritton-1.webp", ratio: "aspect-[3/2]" },
  { cat: "newborn", src: "/allbritton-2.webp", ratio: "aspect-[3/4]" },
  { cat: "newborn", src: "/allbritton-3.webp", ratio: "aspect-[3/2]" },
  { cat: "seniors", src: "/senior-3.webp", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/senior-4.webp", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/senior-5.webp", ratio: "aspect-[3/2]" },
  { cat: "seniors", src: "/senior-6.webp", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/senior-7.webp", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/senior-8.webp", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/senior-9.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/senior-10.jpg", ratio: "aspect-[3/2]" },
  { cat: "seniors", src: "/senior-11.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/senior-12.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/senior-13.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/senior-14.jpg", ratio: "aspect-[3/2]" },
  { cat: "seniors", src: "/senior-15.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/senior-16.jpg", ratio: "aspect-[3/2]" },
  { cat: "seniors", src: "/senior-17.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/parking-1.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/parking-2.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/parking-3.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/parking-4.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/parking-5.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/parking-6.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/parking-7.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/parking-8.jpg", ratio: "aspect-[3/2]" },
  { cat: "seniors", src: "/parking-9.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/parking-10.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/parking-11.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/parking-12.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/senior-graduate-1.jpg", ratio: "aspect-[3/4]" },
  { cat: "seniors", src: "/senior-graduate-2.webp", ratio: "aspect-[3/2]" },
  { cat: "seniors", src: "/senior-graduate-3.jpg", ratio: "aspect-[3/4]" },
  { cat: "milestone", src: "/milestone-session.jpg", ratio: "aspect-[3/4]" },
  { cat: "milestone", src: "/milestone-2.jpg", ratio: "aspect-[3/4]" },
  { cat: "milestone", src: "/milestone-3.jpg", ratio: "aspect-[3/2]" },
  { cat: "milestone", src: "/milestone-4.webp", ratio: "aspect-[3/2]" },
  { cat: "milestone", src: "/milestone-5.webp", ratio: "aspect-[3/2]" },
  { cat: "milestone", src: "/milestone-6.webp", ratio: "aspect-[3/4]" },
  { cat: "milestone", src: "/milestone-7.webp", ratio: "aspect-[3/4]" },
  { cat: "milestone", src: "/milestone-8.webp", ratio: "aspect-[3/4]" },
  { cat: "milestone", src: "/milestone-9.jpg", ratio: "aspect-[3/4]" },
  { cat: "milestone", src: "/milestone-10.jpg", ratio: "aspect-[3/4]" },
  { cat: "milestone", src: "/milestone-11.jpg", ratio: "aspect-[3/4]" },
  { cat: "milestone", src: "/milestone-12.jpg", ratio: "aspect-[3/2]" },
  { cat: "milestone", src: "/milestone-13.webp", ratio: "aspect-[3/2]" },
  { cat: "milestone", src: "/milestone-14.webp", ratio: "aspect-[3/4]" },
  { cat: "milestone", src: "/milestone-15.webp", ratio: "aspect-[3/2]" },
  { cat: "milestone", src: "/milestone-16.webp", ratio: "aspect-[3/4]" },
  { cat: "milestone", src: "/wavy-21.jpg", ratio: "aspect-[3/4]" },
  { cat: "milestone", src: "/kamille-2.webp", ratio: "aspect-[3/4]" },
  { cat: "milestone", src: "/kamille-3.webp", ratio: "aspect-[3/4]" },
  { cat: "milestone", src: "/kamille-4.webp", ratio: "aspect-[3/4]" },
  { cat: "milestone", src: "/kamille-5.webp", ratio: "aspect-[3/4]" },
  { cat: "milestone", src: "/kamille-6.webp", ratio: "aspect-[3/4]" },
  { cat: "heirloom", src: "/heirloom-1.jpg", ratio: "aspect-[3/4]" },
  { cat: "heirloom", src: "/heirloom-2.jpg", ratio: "aspect-[3/4]" },
  { cat: "heirloom", src: "/heirloom-3.jpg", ratio: "aspect-[3/4]" },
  { cat: "heirloom", src: "/heirloom-4.jpg", ratio: "aspect-[3/4]" },
  { cat: "heirloom", src: "/heirloom-5.jpg", ratio: "aspect-[3/4]" },
];

const FILTERS = [{ key: "all", title: "All Work" }, ...CATEGORIES.filter((c) => !c.hidden).map((c) => ({ key: c.key, title: c.title }))];

export default function Portfolio() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialCat = searchParams.get("cat");
  const validKeys = FILTERS.map((f) => f.key);
  const [active, setActive] = useState(
    initialCat && validKeys.includes(initialCat) ? initialCat : "all"
  );

  useEffect(() => {
    const cat = searchParams.get("cat");
    if (cat && validKeys.includes(cat) && cat !== active) {
      setActive(cat);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const handleFilterChange = (key) => {
    setActive(key);
    if (key === "all") {
      setSearchParams({}, { replace: true });
    } else {
      setSearchParams({ cat: key }, { replace: true });
    }
  };

  const shuffledAll = useMemo(() => {
    const a = [...GALLERY];
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }, []);
  const items = useMemo(() => {
    if (active === "all") return shuffledAll;
    const filtered = GALLERY.filter(
      (g) => g.cat === active || (g.cats && g.cats.includes(active))
    );
    // Stable per-filter shuffle so recent additions don't clump at the end
    for (let i = filtered.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [filtered[i], filtered[j]] = [filtered[j], filtered[i]];
    }
    return filtered;
  }, [active, shuffledAll]);
  const catTitle = (k) => CATEGORIES.find((c) => c.key === k)?.title || k;

  const [lightboxIdx, setLightboxIdx] = useState(null);
  const touchStartX = useRef(null);

  const closeLightbox = useCallback(() => setLightboxIdx(null), []);
  const prevImg = useCallback(
    () => setLightboxIdx((i) => (i === null ? i : (i - 1 + items.length) % items.length)),
    [items.length]
  );
  const nextImg = useCallback(
    () => setLightboxIdx((i) => (i === null ? i : (i + 1) % items.length)),
    [items.length]
  );

  useEffect(() => {
    if (lightboxIdx === null) return;
    const onKey = (e) => {
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowLeft") prevImg();
      if (e.key === "ArrowRight") nextImg();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [lightboxIdx, closeLightbox, prevImg, nextImg]);

  // reset lightbox if filter changes while open
  useEffect(() => {
    setLightboxIdx(null);
  }, [active]);

  return (
    <div className="pt-8 md:pt-12">
      <section className="mx-auto max-w-[1400px] px-6 md:px-10">
        <p className="overline text-sage mb-6">The Portfolio</p>
        <RevealText
          as="h1"
          className="font-serif font-light text-ink leading-[0.95] tracking-tight text-5xl sm:text-6xl md:text-7xl"
          lines={["A gallery of", "quiet moments"]}
        />
        <Reveal delay={0.3}>
          <p className="mt-8 max-w-xl text-inksoft leading-relaxed">
            A living archive across family, maternity, branding and more.
            Filter by the story you're looking for.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-[1400px] px-6 md:px-10 mt-14">
        <div data-testid="portfolio-filters" className="flex flex-wrap gap-3 border-b border-ink/10 pb-8">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              data-testid={`filter-${f.key}`}
              onClick={() => handleFilterChange(f.key)}
              className={`rounded-full px-5 py-2 text-[13px] tracking-wide transition-colors duration-300 ${
                active === f.key
                  ? "bg-ink text-cream"
                  : "border border-ink/15 text-inksoft hover:border-ink hover:text-ink"
              }`}
            >
              {f.title}
            </button>
          ))}
        </div>

        <div className="mt-10 columns-2 lg:columns-3 gap-1 md:gap-6 [column-fill:_balance] pb-28">
          {items.map((g, i) => (
            <motion.div
              key={g.src}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "0px 0px -10% 0px" }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: (i % 6) * 0.04 }}
              className="mb-1 md:mb-6 break-inside-avoid group"
              data-testid={`gallery-item-${i}`}
            >
              <button
                type="button"
                onClick={() => setLightboxIdx(i)}
                data-testid={`gallery-open-${i}`}
                aria-label={`Open ${catTitle(g.cat)} image`}
                className={`block w-full cursor-zoom-in ${g.ratio || ""}`}
              >
                <Img
                  src={g.src}
                  alt={catTitle(g.cat)}
                  className="h-full w-full"
                  imgClassName="group-hover:scale-105"
                />
              </button>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="bg-sagelight py-24 md:py-32">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <h2 className="font-serif font-light text-ink text-4xl md:text-6xl leading-tight max-w-xl">
            See a session that fits your story?
          </h2>
          <Link
            to="/investment"
            data-testid="portfolio-cta-link"
            className="group inline-flex items-center gap-3 rounded-full bg-ink text-cream px-9 py-4 text-sm font-medium hover:bg-sagedark transition-colors"
          >
            View investment
            <ArrowUpRight size={17} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
      </section>

      {/* Lightbox */}
      <AnimatePresence>
        {lightboxIdx !== null && items[lightboxIdx] && (
          <motion.div
            key="lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="fixed inset-0 z-[100] bg-ink/95 flex items-center justify-center"
            data-testid="lightbox"
            onClick={closeLightbox}
            onTouchStart={(e) => { touchStartX.current = e.touches?.[0]?.clientX ?? null; }}
            onTouchEnd={(e) => {
              const endX = e.changedTouches?.[0]?.clientX;
              if (touchStartX.current === null || endX == null) return;
              const dx = endX - touchStartX.current;
              if (dx > 50) prevImg();
              else if (dx < -50) nextImg();
              touchStartX.current = null;
            }}
          >
            <button
              type="button"
              aria-label="Close"
              data-testid="lightbox-close"
              onClick={(e) => { e.stopPropagation(); closeLightbox(); }}
              className="absolute top-5 right-5 md:top-8 md:right-8 h-11 w-11 rounded-full bg-cream/10 hover:bg-cream/20 text-cream flex items-center justify-center transition-colors"
            >
              <X size={22} />
            </button>
            <button
              type="button"
              aria-label="Previous image"
              data-testid="lightbox-prev"
              onClick={(e) => { e.stopPropagation(); prevImg(); }}
              className="absolute left-3 md:left-8 top-1/2 -translate-y-1/2 h-12 w-12 rounded-full bg-cream/10 hover:bg-cream/20 text-cream flex items-center justify-center transition-colors"
            >
              <ChevronLeft size={26} />
            </button>
            <button
              type="button"
              aria-label="Next image"
              data-testid="lightbox-next"
              onClick={(e) => { e.stopPropagation(); nextImg(); }}
              className="absolute right-3 md:right-8 top-1/2 -translate-y-1/2 h-12 w-12 rounded-full bg-cream/10 hover:bg-cream/20 text-cream flex items-center justify-center transition-colors"
            >
              <ChevronRight size={26} />
            </button>
            <motion.img
              key={items[lightboxIdx].src}
              src={items[lightboxIdx].src}
              alt={catTitle(items[lightboxIdx].cat)}
              onClick={(e) => e.stopPropagation()}
              initial={{ opacity: 0, scale: 0.98 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
              className="max-h-[88vh] max-w-[92vw] object-contain select-none"
              draggable={false}
            />
            <p className="absolute bottom-5 left-1/2 -translate-x-1/2 text-cream/70 text-xs tracking-[0.2em] uppercase">
              {lightboxIdx + 1} / {items.length} · {catTitle(items[lightboxIdx].cat)}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
